import { getSupportedLocaleCode } from "@/utils/helpers/localeUtils";

const MFA_LOCALES = ["no", "en", "de", "da", "fr", "nl", "sv"] as const;
type MfaLocaleCode = (typeof MFA_LOCALES)[number];

export function useMfaLocale<T>(
  localeMap: Record<MfaLocaleCode, T>,
  locale: string | undefined,
): { localeCode: MfaLocaleCode; locales: T } {
  const localeCode = getSupportedLocaleCode<MfaLocaleCode>(locale, MFA_LOCALES, "no");
  return {
    localeCode,
    locales: localeMap[localeCode],
  };
}
